var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.9 12.9",
    style: {
      enableBackground: "new 0 0 15.9 12.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M15.3,5.9L2,5.8L6.9,1C7,0.9,7,0.8,7,0.6C7,0.4,7,0.3,6.9,0.2C6.7,0.1,6.6,0,6.4,0S6.1,0.1,6,0.2L0.2,6 C0.1,6.1,0,6.3,0,6.5c0,0.2,0.1,0.3,0.2,0.4L6,12.7c0.2,0.2,0.6,0.2,0.8,0C7,12.6,7,12.5,7,12.3C7,12.1,7,12,6.9,11.9L2,7.1l13.3,0 c0.3,0,0.6-0.3,0.6-0.6S15.7,5.9,15.3,5.9z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.7aa2630b.svg";
export { ForwardRef as ReactComponent };